import React from 'react';
import { useDesignMode } from '../../contexts/DesignContext';
import { classNames } from '../../utils/classNames';

interface SketchStickyNoteProps extends React.HTMLAttributes<HTMLDivElement> {
  flat?: boolean;
}

export const SketchStickyNote = React.forwardRef<HTMLDivElement, SketchStickyNoteProps>(
  ({ className, flat = false, children, ...props }, ref) => {
    const { isSketchy } = useDesignMode();

    return (
      <div
        ref={ref}
        className={classNames(
          isSketchy
            ? classNames('sticky-note p-3 rounded-sm', flat && '!rotate-0')
            : 'rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] p-3 shadow-sm',
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

SketchStickyNote.displayName = 'SketchStickyNote';

interface SketchBadgeProps {
  className?: string;
  children: React.ReactNode;
}

export const SketchBadge: React.FC<SketchBadgeProps> = ({ className, children }) => {
  const { isSketchy } = useDesignMode();

  return (
    <span
      className={classNames(
        isSketchy
          ? 'label-typewriter inline-block px-2 py-0.5 border border-dashed border-[var(--color-border)] text-[var(--color-muted)]'
          : 'inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-[var(--color-hover)] text-[var(--color-text)]',
        className
      )}
    >
      {children}
    </span>
  );
};
